/* eslint-disable array-callback-return */
import React from "react";
import { Cityhall, Link } from "../../assets";
import { locales } from "../../locales";
import CommuneAutocomplete from "../Header/CommuneAutocomplete";

const Footer = ({ data, communeQueryHandler, langId, isDesktop }) => {
  const communesInFooter = {
    de: [
      "Luxemburg",
      "Esch/Alzette",
      "Ettelbrück",
      "Grevenmacher",
      "Steinfort",
    ],
    fr: [
      "Luxembourg",
      "Esch-sur-Alzette",
      "Ettelbruck",
      "Grevenmacher",
      "Steinfort",
    ],
    en: ["Luxembourg", "Esch-sur-Alzette", "Ettelbruck"],
    pt: [
      "Luxemburgo",
      "Esch-sur-Alzette",
      "Ettelbruck",
      "Grevenmacher",
      "Steinfort",
    ],
  };

  // click on the link in the footer calls the function communeQueryHandler
  // which is defined in the parent component (CandidatesContainer)
  // and passed as a prop to the Footer component
  const handleLinkClick = (commune) => {
    communeQueryHandler(commune);
  };

  return (
    <div className="p-6 mt-20 bg-wort-background">
      <div className="flex flex-row items-center mb-4">
        <div>
          <div className="w-14 h-14 bg-white flex justify-center items-center rounded-full">
            <Cityhall />
          </div>
        </div>
        <div className="ml-2">
          <span
            className="font-semibold text-xl"
            style={{ fontSize: 22, lineHeight: "26.4px" }}
          >
            {locales[langId].footerTitle}
          </span>
        </div>
      </div>
      <div className="ml-16">
        <CommuneAutocomplete
          isDesktop={isDesktop}
          isFooter={true}
          items={data}
          communeQueryHandler={communeQueryHandler}
          communePlaceholder={locales[langId].communePlaceholder}
          noResultsText={locales[langId].noCommune}
        />
        <div className="mt-6 wort-medium:grid wort-medium:grid-cols-3 wort-medium:gap-1">
          {communesInFooter[langId].map((link, index) => {
            if (index < 5) {
              return (
                <div className="flex flex-row mt-4" key={index}>
                  <Link />
                  <span
                    className="ml-3 font-semibold leading-6 hover:underline cursor-pointer"
                    style={{ color: "#0080B7", fontSize: 18 }}
                    onClick={() => handleLinkClick(link)}
                  >
                    {link}
                  </span>
                </div>
              );
            }
          })}
        </div>
      </div>
    </div>
  );
};

export default Footer;
